import * as messageBox from './ui-message-box.js'
import * as preload from './preload.js'
import * as dataTarot from './data-tarot.js'

export default async function procResult(params) {
    const { app, w, h, cards4 } = params;
    const elementOutput = document.querySelector('#output');
    elementOutput.innerHTML = '';
    const fontRate = 0.7

    cards4.forEach((card, i) => {
        // Show message
        const title = ['質問者の気持ち', '相手の気持ち', '2人の現状', '2人の近い未来'][i];
        const name = dataTarot.cardsName[card.__id];
        const mes = messageBox.gen(app, `${title}\n${name}`, fontRate)
        mes.x = w * [0.2,  0.8,  0.5, 0.5][i];
        mes.y = h * [0.75, 0.75, 0.93, 0.07][i];
        mes.zIndex = 100;

        // Card direction
        const direction = card.__isUpright ? 'upright' : 'reverse';

        // Show output
        const pImg = preload.assets.map(x => x.src).find(x => x.includes(card.__id));
        const rotate = card.__isUpright ? '' : 'output-image-rotate';
        const subtitle = `${name}（${dataTarot.cardDirection[direction]}）`;
        const text1 = dataTarot.cardsText[direction][card.__id][0];
        const text2 = dataTarot.cardsText[direction][card.__id][i + 1];
        const html = 
`<div class="output-block">
    <img src="${pImg}" class="output-image ${rotate}">
    <div class="output-title">${title}</div>
    <div class="output-subtitle">${subtitle}</div>
    <div class="output-text">　${text1}</div>
    <div class="output-text">　${text2}</div>
</div>`;
        elementOutput.insertAdjacentHTML('beforeend', html);
    });

    // Show message
    const mes = messageBox.gen(app, `▼ 詳細`, fontRate)
    mes.x = w * 0.13;
    mes.y = h * 0.95;
}
